import React from "react";
import { ExternalLink, FileSearch, UserCheck } from "lucide-react";
import { transparencyCards } from "../data/mock";

const iconMap = { FileSearch, UserCheck };

export default function Transparency() {
  return (
    <section className="bg-[#ece6d4]/40 px-5 py-24 md:px-10 md:py-28">
      <div className="mx-auto max-w-[1180px]">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-[12px] font-semibold tracking-widest-custom uppercase text-[#9c8345]">
            Transparência
          </span>
          <h2 className="font-serif-display mt-4 text-[38px] leading-[1.1] text-[#0e1a2b] md:text-[52px]">
            Confira nossa atuação real em canais oficiais
          </h2>
          <p className="mt-5 text-[14.5px] leading-relaxed text-[#54657a]">
            Consulte a idoneidade do nosso escritório. Atualmente conduzimos mais de 50
            processos ativos de restituição de ITBI na capital paulista, todos públicos no
            TJSP. Verifique também o registro profissional do advogado responsável
            diretamente no site da OAB/SP.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {transparencyCards.map((card) => {
            const Icon = iconMap[card.icon];
            return (
              <div
                key={card.title}
                className="group relative flex flex-col rounded-xl border border-[#e2dccb] bg-white p-7 elev-card transition hover:border-[#b89c60]/50 md:p-8"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#ece6d4]">
                  <Icon className="h-5 w-5 text-[#9c8345]" strokeWidth={2.4} />
                </div>
                <span className="mt-5 text-[12px] font-semibold tracking-widest-custom uppercase text-[#9c8345]">
                  {card.label}
                </span>
                <h3 className="font-serif-display mt-3 text-[24px] text-[#0e1a2b]">
                  {card.title}
                </h3>
                <p className="mt-3 flex-1 text-[13.5px] leading-relaxed text-[#54657a]">
                  {card.description}
                </p>
                <a
                  href={card.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center gap-2 self-start rounded-md border border-[#0e1a2b] px-4 py-2.5 text-[13px] font-medium text-[#0e1a2b] transition hover:bg-[#0e1a2b] hover:text-[#ebe6d6]"
                >
                  {card.cta}
                  <ExternalLink className="h-3.5 w-3.5" strokeWidth={2.4} />
                </a>
              </div>
            );
          })}
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[12.5px] leading-relaxed text-[#6a7889]">
          Links direcionam aos portais oficiais do Tribunal de Justiça de São Paulo e da
          Ordem dos Advogados do Brasil — Seção São Paulo.
        </p>
      </div>
    </section>
  );
}
